import React, {useCallback, useMemo} from "react";
import {Button, Card, CardActions, CardContent, CardMedia, Divider, Typography} from "@material-ui/core";
import medicoverLogo from "../../assets/medicover_test.jpeg"
import PropTypes from "prop-types";
import {useDispatch} from "react-redux";
import {actions} from '../../actions/cardsActions'
import {useTranslation} from "react-i18next";
import i18n from "../../i18n";
import {CardStatuses} from "../../models/CardsModel";
import moment from "moment/moment";
import numberFormatter from "../../utils/numberFormatter";

const MedicoverCard = ({card}) => {

  const [t] = useTranslation()
  const dispatch = useDispatch();

  const handleAssignCard = useCallback(() => {
    dispatch(actions.medicover())
  }, [dispatch])

  const activateButton = useMemo(() => {
    if (card) return;
    return (
      <CardActions disableSpacing>
        <Button color="secondary" onClick={handleAssignCard}>
          {t('cards.activeMedicoverSport')}
        </Button>
      </CardActions>
    )
  }, [card, handleAssignCard])


  const detailsCurrentCard = useMemo(() => {
    if (!card) return;

    return (
      <React.Fragment>
        <Divider style={{marginTop: 8, marginBottom: 8}}/>
        <div style={{display: 'flex', flexDirection: 'column'}}>
          <Typography variant="caption" style={{color: CardStatuses.activated.color}}
                      display="block">{i18n.t(`cards.cardStatuses.activated`)}</Typography>
          <Typography variant="caption" style={{display: 'flex', gap: 5}}>{i18n.t('cards.amountToUse')}
            <strong>{numberFormatter.format(card.availableFunds)}{' zł'}</strong></Typography>
          <Typography variant="caption" style={{display: 'flex', gap: 5}}>{i18n.t('cards.addedAtLabel')}
            <strong>{moment(card.createdAt).format('DD.MM.YYYY HH:mm')}</strong></Typography>
          <Typography variant="caption" style={{display: 'flex', gap: 5}}>{i18n.t('cards.expireAt')}
            <strong>{moment(card.expireDate).format('DD.MM.YYYY')}</strong></Typography>
        </div>
      </React.Fragment>
    )
  }, [card])

  return (
    <React.Fragment>
      <Card elevation={0} style={{background: 'transparent'}}>
        <CardContent>
          <Card elevation={5}>
            <CardMedia image={medicoverLogo} style={{height: 0, paddingTop: '50%'}}/>
          </Card>
          <Typography variant="subtitle1" style={{marginTop: 20}} display="block"> Medicover Sport</Typography>
          <div>
            {activateButton}
            {detailsCurrentCard}
          </div>
        </CardContent>
      </Card>
    </React.Fragment>
  );

}

MedicoverCard.propTypes = {
  card: PropTypes.object,
};

export default MedicoverCard;
